import React, { useState, useEffect, useRef } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import TextArea from 'components/TextArea';
import ModalVoidConfirm from 'screens/ModalVoidConfirm';
import { Head, Container, Footer } from './styles';

const ModalVoid = ({
  hidden,
  buttonStyle,
  transactionId,
  cardNumber,
  amount,
  voidType,
  setBill
}) => {

  const inputRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const [voidDetails, setVoidDetails] = useState('')
  const [textAreaError, setTextAreaError] = useState(false)

  const handleContinue = () => {
    if(voidDetails === '') {
      setTextAreaError(true)
      return
    }
    setIsOpen(false)
    setConfirmIsOpen(true)
  }
  
  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        danger
        buttonLabel="Void"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Void</Head>
        <Container>
          <TextArea
            inputFieldRef={inputRef}      
            title="VOID DETAILS"
            required
            rows={4}
            error={textAreaError}
            value={voidDetails}
            onChange={(e) => {
              setVoidDetails(e.target.value)
              setTextAreaError(false)
            }}
            additionalstyle={`
              flex-basis: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            onClick={handleContinue}
            additionalstyle={`
              width: 84px;
            `}
          >
            Continue
          </Button>
        </Footer>
      </MainModal>
      <ModalVoidConfirm
        isOpen={confirmIsOpen}
        setIsOpen={setConfirmIsOpen}
        transactionId={transactionId}
        cardNumber={cardNumber}
        amount={amount}
        voidType={voidType}
        voidDetails={voidDetails}
        setVoidDetails={setVoidDetails}
        setBill={setBill}
      />
    </>
  )
}

export default ModalVoid;
